<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="项目名称：" prop="project_id">
                <el-select v-model="model.project_id" clearable :disabled="model.id>0" placeholder="请选择项目">
                    <el-option v-for="item in projectList" :key="'pl'+item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="IP地址：" prop="ip">
                <el-input v-model="model.ip"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getProjectList } from '@/api/org'

export default {
    name: 'accessTokenEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                project_id: '',
                project_name: '',
                access_token: '',
                refresh_token: '',
                expire_time: '',
                create_time: '',
            },
            getObj:{
                url:'/api/admin/accesstoken/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                project_id: [
                    {required: true, message: '请选择项目', trigger: 'blur'}
                ],
                ip: [
                    {required: true, message: '请填写IP地址', trigger: 'blur'}
                ],
            },
            projectList: [],
        };
    },
    methods: {
        loadOtherData() {
            //加载其他内容， 可重写
            getProjectList().then(res=>{
                if(res.code ==1){
                    this.projectList = res.data
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/accesstoken/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>